import React from 'react';
import StatusPage from './StatusPage.jsx';

export const Unauthorized = () => (
  <StatusPage
    code="401"
    title="Unauthorized"
    message="You need to sign in to view this page."
    icon="fa fa-lock"
  />
);

export const Forbidden = () => (
  <StatusPage
    code="403"
    title="Forbidden"
    message="You don't have permission to access this resource."
    icon="fa fa-ban"
  />
);

export const NotFound = () => (
  <StatusPage
    code="404"
    title="Page not found"
    message="The page you’re looking for doesn’t exist or hasn’t been built yet."
    icon="fa fa-compass"
  />
);

export const ServerError = () => (
  <StatusPage
    code="500"
    title="Something went wrong"
    message="An unexpected error occurred. Please try again later."
    icon="fa fa-bug"
  />
);
